class Tabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.tabs__tab');
    this.selfClose = this.dataset.selfClose === 'true';
    this.tabContents = this.querySelectorAll('.js-tab-content');

    this.listeners();
  }

  listeners() {
    this.tabs.forEach(tab => tab.addEventListener('click', event => this.openTab(event)));
  }

  openTab(event) {
    const index = event.target.dataset.index;
    const isActiveTab = event.target.classList.contains('tabs__tab--active');

    this.selfClose && isActiveTab
      ? this.closeSelf(event.target, index)
      : this.toggleTabs(event, index);
  }

  closeSelf(tab, index) {
    tab.classList.remove('tabs__tab--active');

    this.tabContents.forEach(tabContent => {
      if (tabContent.dataset.index === index) tabContent.classList.remove('tabs__content--active');
    });
  }
  
  toggleTabs(event, index) {
    this.tabs.forEach(tab =>
      tab === event.target
        ? tab.classList.add('tabs__tab--active')
        : tab.classList.remove('tabs__tab--active'));

    this.tabContents.forEach(tabContent =>
      tabContent.dataset.index === index
        ? tabContent.classList.add('tabs__content--active')
        : tabContent.classList.remove('tabs__content--active')
    );
  }
}

customElements.define('content-tabs', Tabs);

